<template>
	<b-modal
		size="md"
		ref="modal-add-specimen-weight"
		@hidden="$emit('hidden')"
		ok-title="Guardar"
		:title="`Agregar peso de  ${specimenObj.plate} ${specimenObj.alias ? '(' + specimenObj.alias + ')' : ''}`"
		@ok.prevent="saveSpecimenWeight()"
		centered
	>
		<AddSpecimenWeightBody
			:maxWeight="maxWeight"
			:specimenWeight="specimenWeight"
			:typeWeightOptions="S_TYPE_WEIGHT_OPTIONS"
			@save-weight="saveSpecimenWeight"
		/>
	</b-modal>
</template>

<script>
import moment from "moment"
import { mapActions, mapState } from "vuex"
import AddSpecimenWeightBody from "./AddSpecimenWeightBody.vue"
import modalMixin from "@/mixins/modal.js"
import { showToast } from "@/helpers/toast"
import genderWeightService from "@/views/brain/specimens/views/weights/services/gender-weight.service.js"
export default {
	name: "AddSpecimenWight",
	components: {
		AddSpecimenWeightBody,
	},
	props: {
		specimenObj: Object,
	},
	async mounted() {
		this.isPreloading()
		this.getConfig()
		if (!this.S_TYPE_WEIGHT_OPTIONS.length) {
			await this.A_GET_TYPE_WEIGHT_OPTIONS()
		}
		this.toggleModal("modal-add-specimen-weight")
		this.isPreloading(false)
	},
	data() {
		return {
			specimenWeight: {
				kg_weight: null,
				pounds_weight: 0,
				type_weight: null,
				created_by: null,
				specimen_id: null,
				date_weight: moment().format("YYYY-MM-DD"),
			},
			pesoMaximoHembra: 1,
			pesoMaximoMacho: 1,
		}
	},
	computed: {
		...mapState("weightSpecimen", ["S_TYPE_WEIGHT_OPTIONS"]),
		maxWeight() {
			return this.specimenObj.gender === 1 ? this.pesoMaximoMacho : this.pesoMaximoHembra
		},
	},
	methods: {
		...mapActions("weightSpecimen", ["A_GET_TYPE_WEIGHT_OPTIONS", "A_SAVE_SPECIMEN_WEIGHT"]),
		async getConfig() {
			const { data } = await genderWeightService.getGenderWeights()
			this.pesoMaximoHembra = Number(data.hembra)
			this.pesoMaximoMacho = Number(data.macho)
		},
		async saveSpecimenWeight() {
			if (this.specimenWeight.kg_weight > this.maxWeight) {
				this.showToast(
					"danger",
					"top-right",
					"Peso máximo excedido",
					"AlertTriangleIcon",
					`El peso máximo permitido es ${this.maxWeight} kg`
				)
				return
			}
			if (!this.specimenWeight.kg_weight) {
				this.showToast(
					"danger",
					"top-right",
					"Campos faltantes",
					"AlertTriangleIcon",
					"Faltan campos por llenar"
				)
				return
			}
			try {
				this.isPreloading()
				this.specimenWeight.specimen_id = this.specimenObj.id
				this.specimenWeight.created_by = this.currentUser.user_id
				await this.A_SAVE_SPECIMEN_WEIGHT(this.specimenWeight)
				this.isPreloading(false)
				this.showSuccessToast("El peso del ejemplar fue actualizado con exito")
				this.toggleModal("modal-add-specimen-weight")
				this.$emit("update-specimen-weight", this.specimenObj, this.specimenWeight)
			} catch (error) {
				console.error(error)
			}
		},
	},
	mixins: [modalMixin],
}
</script>

<style></style>
